import { useState } from 'react';

export const useProspectingAssistant = ({ title, location, shouldShowProspectingAssistant }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  const handleExecuteProspectingSearch = text => {
    if (!text) return;
    setSearchText(text);
    closeModal();
    openDrawer();
  };

  const modalProps = shouldShowProspectingAssistant ? { title, location } : {};

  return {
    closeDrawer,
    closeModal,
    handleExecuteProspectingSearch,
    isDrawerOpen,
    isModalOpen,
    modalProps,
    openModal,
    searchText
  };
};
